import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accessToken: null,
  user: null,
  role: null,
  status: 'idle',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authSyncStarted(state) {
      state.status = 'loading';
    },
    authSyncSucceeded(state, action) {
      state.status = 'succeeded';
      state.accessToken = action.payload.accessToken;
    },
    authSyncFailed(state) {
      state.status = 'failed';
      state.accessToken = null;
      state.user = null;
    },
    authUserSynced(state, action) {
      state.user = action.payload.user;
      state.role = action.payload.role;
    },
    authCleared() {
      return initialState;
    },
  },
});

export const { authSyncStarted, authSyncSucceeded, authSyncFailed, authUserSynced, authCleared } =
  authSlice.actions;

export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthUser = (state) => state.auth.user;
export const selectAuthRole = (state) => state.auth.role;
export const selectAuthAccessToken = (state) => state.auth.accessToken;
export const selectIsAdmin = (state) => Boolean(state.auth.user?.is_admin);
export const selectAuthTenantId = (state) => state.auth.user?.tenant_id ?? null;
export const selectAuthTenantName = (state) => state.auth.user?.tenant_name ?? '';

export default authSlice.reducer;
